import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame"];

  load(event) {
    const toggleButton = event.currentTarget;

    if (toggleButton.dataset.lazyFrameLoaded === "false") {
      const url = toggleButton.dataset.lazyFrameUrl;

      const frame = this.frameTarget;
      if (frame) {
        frame.src = url;
        toggleButton.dataset.lazyFrameLoaded = "true";
      }
    }
  }
}
